import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import {
  TimeTrackingServiceCreateResponseJson,
  TimeTrackingServiceGetResponse,
} from '@vmspdb/definitions';
import * as TimeTrackingActions from './time-tracking.actions';

export const timeTrackingsFeatureKey = 'timeTrackings';

export interface TimeTrackingState {
  mine?: TimeTrackingServiceGetResponse;
  myTrackingError?: any;
}

export const adapter: EntityAdapter<TimeTrackingServiceCreateResponseJson> =
  createEntityAdapter<TimeTrackingServiceCreateResponseJson>({
    selectId: (model) => model.uuid || '',
  });

export const initialState: TimeTrackingState = {};

export const reducer = createReducer(
  initialState,
  on(
    TimeTrackingActions.deleteTimeTracking,
    (state, action): TimeTrackingState => state,
  ),
  on(
    TimeTrackingActions.clearTimeTrackings,
    (state): TimeTrackingState => initialState,
  ),
  on(TimeTrackingActions.fetchMyTimeTracking, (state): TimeTrackingState => ({
    ...state,
    myTrackingError: undefined,
    mine: undefined,
  })),
  on(
    TimeTrackingActions.loadMyTimeTracking,
    (state, { mine }): TimeTrackingState => ({ ...state, mine }),
  ),
  on(
    TimeTrackingActions.loadMyTimeTrackingError,
    (state, { error }): TimeTrackingState => ({
      ...state,
      myTrackingError: error,
    }),
  ),
  on(TimeTrackingActions.clearMyTimeTracking, (state): TimeTrackingState => ({
    ...state,
    mine: undefined,
    myTrackingError: undefined,
  })),
  on(
    TimeTrackingActions.startMyTimeTrackingForSurvey,
    (state): TimeTrackingState => ({
      ...state,
    }),
  ),
  on(
    TimeTrackingActions.stopMyTimeTrackingForSurvey,
    (state): TimeTrackingState => ({
      ...state,
    }),
  ),
);

export const { selectIds, selectEntities, selectAll, selectTotal } =
  adapter.getSelectors();

export const timeTrackingSelectors = adapter.getSelectors();
